import { OktaAuth } from '@okta/okta-auth-js'

const oktaAuth = new OktaAuth({
  issuer: process.env.OKTA_ISSUER,
  clientId: process.env.OKTA_CLIENT_ID,
  redirectUri: window.location.origin + '/login/callback',
  postLogoutRedirectUri: `${window.location.origin}/logout`,
  scopes: ['openid', 'readwrite', 'user_impersonation'],
  pkce: true,
})

export default oktaAuth
